import { BarChart } from '../../../../renderers/bar-chart/bar-chart.component';
import { ChartRendererProps } from '../../../../types/chart-renderer-props';
import { PUDO_TRANSACTION_VOLUME_BAR_CHART_DEFINITION } from './pudo-transaction-volume-bar-chart.definition';
import { PUDO_TRANSACTION_VOLUME_BAR_CHART_MOCK_DATA } from './pudo-transaction-volume-bar-chart.mock';

export const PudoTransactionVolumeBarChart = (props: ChartRendererProps) => (
    <BarChart
        {...props}
        stacked
    />
);

PudoTransactionVolumeBarChart.definition = PUDO_TRANSACTION_VOLUME_BAR_CHART_DEFINITION;
PudoTransactionVolumeBarChart.mockData = PUDO_TRANSACTION_VOLUME_BAR_CHART_MOCK_DATA;
